module.exports = __webpack_public_path__ + "img/hkie-white.26f1f3ee.png";